module.exports = __webpack_public_path__ + "media/8.a21150e1.mp3";